import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SrmComponent } from "./srm.component";
import { CreateSrmComponent } from './create-srm/create-srm.component';


const routes: Routes = [
    {
      path: '',
      component: SrmComponent,
    },
    {
      path: 'new-chat',
      component: CreateSrmComponent,
    }
  ];


@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SrmRoutingModule{

}